import {
  cardBadge,
  cardHeader,
  cardTitle,
  customStreamCard,
} from '@/routes/_app.p.streams_.$id/stream-banner/custom-stream-components/custom-stream-info-card.css.ts';
import { streamDescription } from '@/routes/_app.p.streams_.$id/stream-banner/stream-banner.css.ts';

export const CustomStreamInfoCard = () => {
  return (
    <div className={customStreamCard}>
      <div className={cardHeader}>
        <h5 className={cardTitle}>Custom streams let you control the feed.</h5>
        <div className={cardBadge}>Custom stream</div>
      </div>
      <p className={streamDescription}>
        You define the data you want to track. Provide your own targets, and
        this stream will monitor them, delivering real-time updates tailored to
        your needs.
      </p>
    </div>
  );
};
